import {
  STOCK_MASSIVE_UPLOAD_VALIDATE_INCONSISTENCIES_BEGIN,
  STOCK_MASSIVE_UPLOAD_VALIDATE_INCONSISTENCIES_SUCCESS,
  STOCK_MASSIVE_UPLOAD_VALIDATE_INCONSISTENCIES_FAILURE,
  STOCK_MASSIVE_UPLOAD_VALIDATE_INCONSISTENCIES_DISMISS_ERROR,
  STOCK_MASSIVE_UPLOAD_VALIDATE_MOVE_TO_NEXT_INCONSISTENCIES,
} from "./constants";
import { cloneDeep } from "lodash"
import { BFFAgent } from "../../../common/BFFAgent";

export function validateInconsistencies() {
  return (dispatch, getState) => {
    const {
      stock: { stockToProcess, translatorStepKey },
    } = getState();

    dispatch({
      type: STOCK_MASSIVE_UPLOAD_VALIDATE_INCONSISTENCIES_BEGIN,
    });
    let filteredStockToProcess = stockToProcess.filter(stock => stock?.hasNonEquivalence !== true)
    const doRequest = BFFAgent.Stock.validateInconsistencies(
      translatorStepKey,
      filteredStockToProcess
    );
    doRequest.then(
      (res) => {
        const stockToProcessClone = cloneDeep(stockToProcess)
        for (let item of res.translatedRows){
          const translationItem = item[translatorStepKey]
          const stock = stockToProcessClone?.find(itemStock => item.index === itemStock.index)
          stock[translatorStepKey] = translationItem
        }
        if (res.inconsistencies?.length > 0) {
          let { inconsistencies } = res;
          res.inconsistencies = inconsistencies.map(inconsistency => {
            inconsistency.values.unshift({
              id: null,
              name: 'No encontré equivalencia'
            })

            return inconsistency;
          })
          dispatch({
            type: STOCK_MASSIVE_UPLOAD_VALIDATE_INCONSISTENCIES_SUCCESS,
            data: {
              translatorStepKey,
              res,
              stockToProcessClone
            },
          });
        } else {
          dispatch({
            type: STOCK_MASSIVE_UPLOAD_VALIDATE_MOVE_TO_NEXT_INCONSISTENCIES,
            data: {
              translatorStepKey,
              stockToProcessClone,
            }
          });
        }
      },
      (err) => {
        dispatch({
          type: STOCK_MASSIVE_UPLOAD_VALIDATE_INCONSISTENCIES_FAILURE,
          data: { error: err },
        });
      }
    );
  };
}
export function dismissUploadCargaMasiva() {
  return {
    type: STOCK_MASSIVE_UPLOAD_VALIDATE_INCONSISTENCIES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_MASSIVE_UPLOAD_VALIDATE_INCONSISTENCIES_BEGIN:
      return {
        ...state,
        validateInconsistenciesPending: true,
        validateInconsistenciesError: null,
      };

    case STOCK_MASSIVE_UPLOAD_VALIDATE_INCONSISTENCIES_SUCCESS:
      return {
        ...state,
        translator: {
          ...state.translator,
          [action.data.translatorStepKey]: {
            inconsistencies: action.data.res.inconsistencies,
            completed: false,
            order:
              state.schema[action.data.translatorStepKey].order,
          },
        },
        validateInconsistenciesPending: false,
        validateInconsistenciesError: null,
        stockToProcess: action.data.stockToProcessClone
      };

    case STOCK_MASSIVE_UPLOAD_VALIDATE_MOVE_TO_NEXT_INCONSISTENCIES:
      let newTranslatorStep;
      let newTranslatorStepKey;
      const nextStepOrder = state.translatorStep + 1;
      let currentStep;
      let completedStepper = false;
      for (let schemaKey in state.schema) {
        currentStep = state.schema[schemaKey];
        if (currentStep.order === nextStepOrder && currentStep.requiresValidation) {
          newTranslatorStepKey = schemaKey;
          newTranslatorStep = nextStepOrder;
          break
        }
        if (currentStep.order + 1 === state.translatorSteps.length){
          completedStepper = true;
        }
      }
      return {
        ...state,
        stockToProcess: action.data.stockToProcessClone,
        translatorStep: newTranslatorStep
          ? newTranslatorStep
          : state.translatorStep,
        translatorStepKey: newTranslatorStepKey
          ? newTranslatorStepKey
          : state.translatorStepKey,
        lastTranslationStep: newTranslatorStep 
          ? newTranslatorStep
          : state.translatorStep,
        validateInconsistenciesPending: currentStep.requiresValidation,
        validateInconsistenciesError: !currentStep.requiresValidation && null,
        completedStepper
      };
    case STOCK_MASSIVE_UPLOAD_VALIDATE_INCONSISTENCIES_FAILURE:
      return {
        ...state,
        validateInconsistenciesPending: false,
        validateInconsistenciesError: action.data.error,
      };

    case STOCK_MASSIVE_UPLOAD_VALIDATE_INCONSISTENCIES_DISMISS_ERROR:
      return {
        ...state,
        validateInconsistenciesError: null,
      };

    default:
      return state;
  }
}
